import React from 'react';
import { Provider } from 'react-redux'
import { store } from './store'

import './language';
import './scss/shared.scss';

import App from './components/router/router';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { initAnalytics, trackWebVital } from './analytics';
import { initObservability, FrontendErrorBoundary } from './observability';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
initAnalytics("app-home");
initObservability({
  applicationName: 'app-home',
  propagationTargets: [/^\//, /\.scaratec\.com/, /\.clipsymphony\.com/, /\.clipsynphony\.com/, 'localhost'],
  // Build-time override: set REACT_APP_OTEL_TRACES_URL to an absolute URL
  // (e.g. in .env.development) to ship browser spans cross-origin during
  // `npm start`. Prod builds leave it unset and fall back to the same-
  // origin default `/clip/otel/v1/traces`.
  otlpTracesPath: process.env.REACT_APP_OTEL_TRACES_URL || undefined,
});
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <FrontendErrorBoundary applicationName="app-home">
        <App />
      </FrontendErrorBoundary>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => trackWebVital("app-home", metric));
